module.exports = __webpack_public_path__ + "img/tr.b4a15832.svg";